// extracted by mini-css-extract-plugin
module.exports = {"icon":"FilterLanguages_icon__358P1","noLanguagesMessage":"FilterLanguages_noLanguagesMessage__raCDp"};